import { siteMeta } from '@/mocks/cinema';

const cols = [
  {
    title: '数据栏目',
    links: [
      { label: '实时票房榜', target: 'boxoffice' },
      { label: '今日排片场次', target: 'schedule' },
      { label: '本周上映名单', target: 'release' },
      { label: '档期窗口', target: 'window' },
    ],
  },
  {
    title: '资讯解读',
    links: [
      { label: '票房观察', target: 'news' },
      { label: '排片解读', target: 'news' },
      { label: '上映资讯', target: 'news' },
      { label: '购票指南', target: 'news' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '关于吃瓜影院', target: 'about' },
      { label: '常见问题', target: 'faq' },
      { label: '投稿联系', target: 'about' },
      { label: '合作洽谈', target: 'about' },
    ],
  },
];

export default function Footer() {
  const go = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-background-200">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <a href="#top" onClick={(e) => { e.preventDefault(); go('top'); }} className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-600 text-background-50">
                <i className="ri-movie-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-900">{siteMeta.name}</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              {siteMeta.name} 实时汇总票房排行、影院排片、新片上映与档期窗口，帮你快速锁定想看的场次与热度影片。
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {[
                '实时票房', '排片表', '上映名单', '档期',
              ].map((t) => (
                <span
                  key={t}
                  className="rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-foreground-700"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-heading text-sm font-bold text-foreground-900">{c.title}</h4>
              <ul className="mt-3 space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={`#${l.target}`}
                      onClick={(e) => {
                        e.preventDefault();
                        go(l.target);
                      }}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} {siteMeta.name} · 本站票房与排片数据为资讯参考，最终以影城实际出票为准
          </p>
          <p className="flex items-center gap-1 text-xs text-foreground-500">
            让每一场电影都物有所值
            <i className="ri-heart-3-fill text-primary-500"></i>
          </p>
        </div>
      </div>
    </footer>
  );
}